import { IMAGES } from "@/data/content";
import { MaskLine, FadeUp } from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "The 5 AM Ritual",
    body: "Every morning begins at five. Samosas leave the kadhai hot, rotis come off the tawa, and the first bogni is ready long before the school bell rings across the road.",
  },
  {
    num: "02",
    title: "Only Pure Desi Ghee",
    body: "Our mithai, geer jilebi and nimki are made in pure desi ghee — no shortcuts, no compromises. The way sweets are supposed to taste.",
  },
  {
    num: "03",
    title: "Bappu's Counter",
    body: "Owner Bappu runs the counter himself — weighing mithai by the piece, curating celebration platters, and greeting every customer by name.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-20 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-14 lg:gap-16 items-center">
        <FadeUp className="lg:col-span-5 relative">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full rounded-3xl border border-gold/30" aria-hidden="true" />
            <img
              src={IMAGES.aboutShop}
              alt="Inside the Samij Sweets counter in Banskandi"
              loading="lazy"
              className="relative w-full aspect-[4/3] object-cover rounded-3xl shadow-[0_40px_80px_-40px_rgba(0,0,0,0.9)]"
            />
            <div className="absolute -bottom-6 -right-3 sm:-right-6 rounded-2xl bg-cocoa-900 border border-gold/30 px-5 py-4 shadow-xl">
              <p className="font-bengali text-gold text-lg leading-none">মিষ্টি মানে ভালোবাসা</p>
              <p className="mt-1.5 text-[10px] uppercase tracking-[0.25em] text-cream/50">Sweets mean love</p>
            </div>
          </div>
        </FadeUp>

        <div className="lg:col-span-7">
          <FadeUp>
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold">About Us · আমাদের কথা</p>
          </FadeUp>
          <h2 className="mt-4 font-display font-semibold text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-cream">
            <MaskLine>A neighbourhood halwai,</MaskLine>
            <MaskLine delay={0.1}>
              run <em className="italic font-light text-gold">the old way</em>
            </MaskLine>
          </h2>

          <div className="mt-10 space-y-9">
            {CHAPTERS.map((c, i) => (
              <FadeUp key={c.num} delay={i * 0.1} className="flex gap-6 sm:gap-8">
                <span className="font-display text-4xl sm:text-5xl font-light text-gold/25 leading-none pt-1 shrink-0">
                  {c.num}
                </span>
                <div>
                  <h3 className="font-display font-semibold text-xl text-cream">{c.title}</h3>
                  <p className="mt-2 text-cream/65 leading-relaxed text-base">{c.body}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
